export function formatMinutes(minutes: number): string {
  // Calculate the number of hours
  const hoursParsed = Math.floor(minutes / 60);

  // Calculate the remaining minutes
  const remainingMinutesParsed = minutes % 60;

  // Pad the hours and minutes with leading zeros if necessary and format the result
  const hoursFormatted = String(hoursParsed).padStart(2, '0');
  const minutesFormatted = String(remainingMinutesParsed).padStart(2, '0');

  return `${hoursFormatted}:${minutesFormatted}`;
}
